<template>
  <div style="margin: 18px 18px;">
    <table id="head-page">
      <tr>
        <td style="width: 60%;">
          <!-- <img
            :src="
              invoiceResources.company
                ? invoiceResources.company.image_logo
                : ''
            "
            alt="No image"
          /> -->
          <img src="../../../assets/tslogo.png" alt="No image" />
          <div id="company-name">
            <h2>
              <span class="kh-moul-font">{{
                invoiceResources.company
                  ? invoiceResources.company.company_name_kh
                  : ''
              }}</span>
              <span style="line-height: 20px;"
                >&nbsp;&nbsp;{{
                  invoiceResources.branch
                    ? invoiceResources.branch.branch_name_kh
                    : ''
                }}</span
              >
            </h2>
            <h2>
              <span
                ><b>{{
                  invoiceResources.company
                    ? invoiceResources.company.company_name_en
                    : ''
                }}</b></span
              >
              <span
                ><b
                  >&nbsp;&nbsp;{{
                    invoiceResources.branch
                      ? invoiceResources.branch.branch_name_en
                      : ''
                  }}</b
                ></span
              >
            </h2>
          </div>
        </td>
        <td style="max-width:40%;" class="text-right">
          <img
            style="float: right; width: 120px; height:25px"
            :src="invoiceResources ? invoiceResources.barcode_image : ''"
            alt="barcode"
          />
        </td>
      </tr>
    </table>

    <div style="width: 100%;" class="text-center">
      <h2 class="text-center">
        <span class="kh-moul-font bb">វិក័យប័ត្រ/INVOICE</span>
      </h2>
    </div>

    <table id="invoice-info">
      <tr>
        <td style="width: 60%;" valign="top">
          <table>
            <tr>
              <td style="width: 36%;">
                <p>ឈ្មោះសិស្ស/Student Name</p>
              </td>
              <td>
                <p>
                  :
                  <b>{{
                    invoiceResources.student
                      ? invoiceResources.student.full_name_en
                      : ''
                  }}</b>
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>លេខប័ណ្ណសម្គាល់ខ្លួនសិស្ស/ID No</p>
              </td>
              <td>
                <p>
                  :
                  <b>{{
                    invoiceResources.student
                      ? invoiceResources.student.card_number
                      : ''
                  }}</b>
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>ទូរស័ព្ទ/Telephone</p>
              </td>
              <td>
                <p>
                  :
                  {{
                    invoiceResources.student
                      ? invoiceResources.student.phone
                      : ''
                  }}
                </p>
              </td>
            </tr>
            <tr>
              <td class="nowrap">
                <p>លេខអត្តសញ្ញាណកម្ម អ.ត.ប/VATTIN</p>
              </td>
              <td>
                <p>
                  :
                  {{
                    invoiceResources.company
                      ? invoiceResources.company.vat_number
                      : ''
                  }}
                </p>
              </td>
            </tr>
          </table>
        </td>
        <td valign="top">
          <table>
            <tr>
              <td style="width: 53%;">
                <p>លេខរៀងវិកយបត្រ/Invoice No.</p>
              </td>
              <td>
                <p>
                  : {{ invoiceResources ? invoiceResources.inv_number : '' }}
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>កាលបរិច្ឆេទ/Date</p>
              </td>
              <td>
                <p>: {{ invoiceResources ? invoiceResources.inv_date : '' }}</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>ថ្នាក់ទី/Grade</p>
              </td>
              <td>
                <p>
                  :
                  {{
                    invoiceResources.grade
                      ? invoiceResources.grade.grade_name_foreign
                      : ''
                  }}
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>ម៉ោងសិក្សា/Study Time</p>
              </td>
              <td>
                <p>
                  :
                  {{
                    invoiceResources.study_time
                      ? invoiceResources.study_time
                      : ''
                  }}
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>លក្ខខណ្ឌបង់ប្រាក់/Payment Type</p>
              </td>
              <td>
                <p>
                  :
                  {{
                    invoiceResources.payment_method
                      ? invoiceResources.payment_method
                      : ''
                  }}
                </p>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>

    <table id="item-detail">
      <thead>
        <tr>
          <th style="width: 15%;" class="bl bt bb">
            ប្រភេទថ្លៃឈ្នួល <br />
            Fee Type
          </th>
          <th style="width: 21%;" class="text-left bl bt bb">
            <p>បរិយាយ</p>
            <p>Description</p>
          </th>
          <th style="width: 7%;" class="bl bt bb text-center">
            <p>ចំនួន</p>
            <p>Quantity</p>
          </th>
          <th style="width: 8%;" class="bl bt bb text-center">
            <p>តំលៃឯកតា</p>
            <p>Unit Price</p>
          </th>
          <th style="width: 3%;" class="bl bb bt text-center">
            <p>អប្បមា</p>
            <p>Dis</p>
          </th>
          <th style="width: 5.5%;" class="bb bt bl nowrap text-center">
            <p>អតប %</p>
            <p>VAT %</p>
          </th>
          <th style="width: 9%;" class="text-right bb bt bl pr">
            <p>ទឹកប្រាក់</p>
            <p>Amount</p>
          </th>
          <th class="bb bt bl text-center">
            <p>ថ្ងៃចាប់ផ្តើម</p>
            <p>Starting Date</p>
          </th>
          <th class="bb bt bl br text-center">
            <p>ថ្ងៃបញ្ចប់</p>
            <p>Ending Date</p>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(detail, index) in invoiceResources.invoice_detail"
          :key="index"
        >
          <td class="bl pl pb">
            {{ detail.fee_type ? detail.fee_type.fee_type_name : '' }}
          </td>
          <td class="bl pl pb">
            {{ detail.fee_description ? detail.fee_description : '' }}
          </td>
          <td class="text-center bl pb">
            {{ detail.quantity ? detail.quantity : '' }}
          </td>
          <td class="text-center bl pb">
            $ {{ detail.fee_amount ? detail.fee_amount : 0 }}
          </td>
          <td class="text-center bl pb">
            {{ detail.discount_rate + ' ' + detail.discount_type }}
          </td>
          <td class="text-center bl pb">
            {{ detail.vat_rate }}
          </td>
          <td class="text-right bl pr pb">
            $ {{ detail.amount_include_vat ? detail.amount_include_vat : '' }}
          </td>
          <td class="text-center bl pb">
            {{ detail.fee_start_date ? detail.fee_start_date : '' }}
          </td>
          <td class="text-center bl br pb">
            {{ detail.fee_end_date ? detail.fee_end_date : '' }}
          </td>
        </tr>
        <tr
          v-for="i in 7 -
            (invoiceResources.invoice_detail
              ? invoiceResources.invoice_detail.length
              : 0)"
        >
          <td class="bl" height="14"></td>
          <td class="bl"></td>
          <td class="text-center bl"></td>
          <td class="text-center bl"></td>
          <td class="text-center bl"></td>
          <td class="text-right bl"></td>
          <td class="text-center bl"></td>
          <td class="text-center bl"></td>
          <td class="text-center bl br"></td>
        </tr>
        <tr>
          <td colspan="9" class="bb bl br" style="height:0;"></td>
        </tr>
        <tr>
          <td
            colspan="2"
            rowspan="3"
            class="bl bb"
            style="vertical-align: top;"
          >
            <ul>
              <li
                style="margin-bottom: 6px;padding-left: 5px;  padding-top: 10px;"
              >
                All payment are not transferable or refundable
              </li>
              <li style="position: relative; padding-left: 5px;">
                ថ្ងៃខែត្រូវបង់បន្ទាប់/Next Payment Date
                <b>
                  {{
                    invoiceResources.next_payment_date
                      ? invoiceResources.next_payment_date
                      : 'N/A'
                  }}
                </b>
              </li>
            </ul>
          </td>
          <td
            colspan="3"
            class="bl bb"
            style="padding-bottom: 10px;padding-left: 3px;"
          >
            សរុបរង/Sub-Total
          </td>
          <td
            class="bl bb text-right"
            style="padding-bottom: 10px;padding-right: 5px;"
          >
            $
            {{
              invoiceResources.total_amount ? invoiceResources.total_amount : ''
            }}
          </td>
          <td
            colspan="3"
            rowspan="5"
            class="bl br bb"
            valign="top"
            style="padding-left: 5px;"
          >
            <u
              style="display: inline-block; padding-bottom: 7px;padding-top: 5px;"
            >
              កំណត់សម្គាល់/Note:
            </u>

            <p>
              {{ invoiceResources.remark ? invoiceResources.remark : '' }}
            </p>
          </td>
        </tr>
        <tr>
          <td
            class="bl bb"
            colspan="3"
            style="padding-bottom: 10px; padding-left: 5px;"
          >
            <p style="margin: 0;">អ.ត.ប/VAT</p>
          </td>
          <td
            class="bl bb text-right"
            style="padding-bottom: 10px;padding-right: 5px;"
          >
            <p>0</p>
          </td>
        </tr>
        <tr>
          <td
            colspan="3"
            class="bl bb"
            style="padding-bottom: 10px;padding-left: 5px;"
          >
            <p>សរុបរួម/Grand Total</p>
          </td>
          <td
            class="bl bb text-right"
            style="padding-bottom: 10px;padding-right: 5px;"
          >
            <p>
              $
              {{
                invoiceResources.total_amount
                  ? invoiceResources.total_amount
                  : ''
              }}
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="2" rowspan="2" class="bl bb" style="padding-left: 3px;">
            <span>ទឹកប្រាក់បានបង់ជាអក្សរ/Paid Amount in word</span><br />
            <p>
              {{
                invoiceResources.amount_in_word
                  ? invoiceResources.amount_in_word
                  : ''
              }}
            </p>
          </td>
          <td
            colspan="3"
            class="bl bb nowrap"
            style="padding-bottom: 10px;padding-left: 5px;"
          >
            <p>ទឹកប្រាក់បានបង់/Paid Amount</p>
          </td>
          <td class="bl bb text-right">
            <p style="padding-bottom: 10px;padding-right: 5px;">
              $
              {{
                invoiceResources.amount_paid ? invoiceResources.amount_paid : ''
              }}
            </p>
          </td>
        </tr>
        <tr>
          <td
            colspan="3"
            class="bl bb"
            style="padding-bottom: 10px;padding-left: 5px;"
          >
            <p>
              ទឹកប្រាក់ជំពាក់/Amount Due
            </p>
          </td>
          <td
            class="bl bb text-right"
            style="padding-bottom: 10px;padding-right: 5px;"
          >
            <p>
              $
              {{
                invoiceResources.amount_due ? invoiceResources.amount_due : ''
              }}
            </p>
          </td>
        </tr>
        <tr>
          <td
            colspan="2"
            class="bb bl nowrap"
            style="padding-bottom: 10px;padding-left: 3px;"
          >
            <p>ហត្ថលេខានិងឈ្មោះអតិថិជន/Customer's Signature and Name</p>
          </td>
          <td
            colspan="7"
            class="bb br bl"
            style="padding-bottom: 10px;padding-left: 5px;"
          >
            <p>ហត្ថលេខានិងឈ្មោះបេឡាករ/Cashier's Signature and Name</p>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="bb bl" style="height: 40px;"></td>
          <td colspan="7" class="bb br bl" valign="bottom">
            <table>
              <tr>
                <td style="width: 50%;padding-bottom: 10px;padding-left: 5px;">
                  Printed On: {{ getCurrentDateTime() }}
                </td>
                <td style="padding-bottom: 10px;">
                  <b class="kh-font">{{
                    invoiceResources.user && invoiceResources.user.employee
                      ? invoiceResources.user.employee.name_en
                      : invoiceResources.user
                      ? invoiceResources.user.loginname
                      : ''
                  }}</b>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td colspan="9" style="padding-left: 5px;">
            <p style="padding-bottom: 5px;">
              Address:
              {{
                invoiceResources.branch ? invoiceResources.branch.address : ''
              }}
            </p>
            <p>
              Tel:
              {{ invoiceResources.branch ? invoiceResources.branch.phone : '' }}
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: 'studentInvoiceEn',
  props: ['invoiceResources'],
  data() {
    return {
      loading: false
    }
  },
  methods: {
    getCurrentDateTime() {
      const now = new Date()
      const day = String(now.getDate()).padStart(2, '0')
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const year = now.getFullYear()
      let hours = now.getHours()
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const ampm = hours >= 12 ? 'PM' : 'AM'
      hours = hours % 12
      hours = hours ? hours : 12
      hours = String(hours).padStart(2, '0')

      return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`
    }
  }
}
</script>
<style lang="scss" scoped>
@font-face {
  font-family: 'Open_Sans';
  src: url('/assets/fonts/Open_Sans.ttf') format('truetype');
}

@font-face {
  font-family: 'KhmerOS';
  src: url('/assets/fonts/KhmerOS.ttf') format('truetype');
}

@font-face {
  font-family: 'Khmer_OS_Muol';
  src: url('/assets/fonts/Khmer_OS_Muol.ttf') format('truetype');
}

* {
  padding: 0;
  margin: 0;
  font-size: 10px;
  font-family: 'Open_Sans', 'KhmerOS';
  color: #000000;
}

table td {
  line-height: 1;
}

.kh-moul-font {
  font-family: Khmer_OS_Muol;
}

table {
  width: 100%;
  border-collapse: collapse;
}

#head-page img {
  width: 100px;
  float: left;
}

#invoice-info td {
  padding-bottom: 10px;
}

#company-name {
  margin-top: 10px;
  float: left;
  line-height: 10px;
}

#company-name > h2 {
  margin: auto 5px;
  font-size: 18px;
}

#item-detail {
  margin-top: 10px;
}

#item-detail th {
  padding-left: 5px;
  padding-bottom: 10px;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.bt {
  border-top: 1px solid #404040;
}

.bb {
  border-bottom: 1px solid #404040;
}

.br {
  border-right: 1px solid #404040;
}

.bl {
  border-left: 1px solid #404040;
}

.nowrap {
  white-space: nowrap !important;
}

.pl {
  padding-left: 5px;
}

.pr {
  padding-right: 5px;
}

.pb {
  padding-bottom: 5px;
}
ul {
  list-style: none;
}

ul li {
  position: relative;
  line-height: 1.5;
}

ul li::before {
  content: '•';
  position: absolute;
  left: -10px;
  top: 10;
  font-size: 14px;
  color: #000;
  line-height: 1;
}
</style>
